<template>
  <div>
    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onEditSubmit)">
        <div>
          <div class="mt-4 mb-4">
            <FileUploader
              v-show="!image"
              :image="image"
              :onSuccess="handleSuccess"
              class="rounded-full widtht30percent m-auto display-none custmodal"
            />
            <!-- <img
              v-if="image"
              :src="image"
              ref="cover"
              class="rounded-full widtht30percent m-auto display-none custmodal"
            /> -->
            <img
              v-if="image"
              :src="
                image.slice(0, 4) === 'data' ? image : `${$imageURL}/${image}`
              "
              ref="cover"
              class="rounded-full widtht20percent m-auto display-none custmodal"
            />
            <div
              class="text-center text-red"
              v-if="image"
              @click="handleRemove"
            >
              Remove image
            </div>
            <p class="text-center">Upload your cover photo</p>
          </div>

          <b-form-group
            id="input-group-3"
            label="Select Category"
            label-for="input-3"
          >
            <b-form-select
              id="input-3"
              v-model="selectedCategory"
              :options="categoryOption"
              required
            ></b-form-select>
          </b-form-group>

          <b-form-group label="Name">
            <base-input
              :rules="{
                required: true,
                alpha_spaces: true,
              }"
              v-model="name"
              placeholder="name"
              name="name"
            ></base-input>
          </b-form-group>
          <b-form-group label="Designation">
            <base-input
              :rules="{
                required: true,
              }"
              v-model="designation"
              placeholder="Enter designation name"
              name="designation"
            ></base-input>
          </b-form-group>
          <b-form-group label="Description">
            <base-input
              :rules="{
                required: true,
              }"
              v-model="description"
              :v-html="description"
              placeholder="Enter description name"
              name="description"
            ></base-input>
          </b-form-group>
          <b-form-group label="LinkedIn URL">
            <base-input
              :rules="{
                regex:
                  '(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?',
              }"
              v-model="linkedIn"
              placeholder="URL"
              name="linkedIn"
              type="url"
            ></base-input>
          </b-form-group>

          <div class="flex justify-center mt-2">
            <b-button type="submit" variant="primary">Save</b-button>
          </div>
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>
<script>
import FileUploader from "../../../../../../components/FileUploader.vue";

export default {
  components: {
    FileUploader,
  },
  props: {
    editData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      drawer: true,
      categoryOption: [
        { text: "Select One", value: null },
        { text: "Team", value: "team" },
        { text: "Mentor", value: "mentor" },
        { text: "Advisor", value: "advisor" },
        { text: "Board Members", value: "board members" },
      ],
      name: "",
      designation: "",
      description: "",
      selectedCategory: null,
      linkedIn: "",
      image: null,
      coverImage: null,
    };
  },
  methods: {
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          // text: "Please ensure that the file size does not exceed 5MB",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.coverImage = image;
      this.readerData(image);
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onEditSubmit() {
      this.name = this.name.trim();
      if (this.designation) {
        this.designation = this.designation.trim();
      }
      this.description = this.description.trim();
      this.selectedCategory = this.selectedCategory.trim();
      if (this.linkedIn) {
        this.linkedIn = this.linkedIn.trim();
      }

      const payload = new FormData();
      payload.append("name", this.name);
      payload.append("aboutUsId", this.editData._id);

      if (this.designation) payload.append("designation", this.designation);
      if (this.description) payload.append("description", this.description);
      if (this.selectedCategory)
        payload.append("category", this.selectedCategory);
      if (this.linkedIn) payload.append("linkedIn", this.linkedIn);
      if (this.coverImage) payload.append("image", this.coverImage);

      let loader;

      try {
        // console.log(payload);
        loader = this.$loading();
        const editAboutUs = await this.$store.dispatch(
          "aboutUs/editAboutUs",
          payload
        );

        if (editAboutUs.code === 200) {
          // console.log(editAboutUs);
          this.$emit("close");
          loader.close();
          await this.$swal({
            text: `Profile has been successfully updated!`,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });

          this.name = "";
          this.designation = "";
          this.description = "";
          this.linkedIn = "";
          this.coverImage = null;
          this.selectedCategory = null;
          this.image = null;
          // this.getAboutUs();
        }
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    closeModal() {
      this.$emit("close");
      // this.$bvModal.hide("modal-22");
    },
  },
  mounted() {
    this.name = this.editData.name;
    this.designation = this.editData.designation;
    this.description = this.editData.description.replace(/<[^>]*>/g, "");
    this.linkedIn = this.editData.linkedIn;
    this.selectedCategory = this.editData.category;
    this.image = this.editData.image;
  },
};
</script>
